<template>
  <div class="d-prod">
    <div id="process" class="process">
      <div
           v-for="(item, index) in typeList"
           :key="index"
           class="step"
           :class="{ isActived: actived === index }"
           @click="handleChange(item)">
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  computed: {
    actived() {
      return this.chooseType;
    }
  },
  data() {
    return {
      pages: 1,
      pageSize: 5,
      lastPage: 2,
      isShow: false,
      steps: [],
      typeList: [],
      productList: [],
      chooseType: null,
      classprocess:process,
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        this.steps = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
        let nowProductType = this.steps.find(item => {
          if (item.identification) {
            return this.$route.params.identification == item.identification;
          } else {
            return this.$route.params.identification == item.id;
          }
        });
        if (nowProductType) {
          let fatherTarget = this.steps.find(item => item.id == nowProductType.pid);
          this.typeList = this.steps.filter(item => item.pid == fatherTarget.pid);
          this.chooseType = this.typeList.findIndex(item => item.id === fatherTarget.id);
        }
      }
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    handleChange(item) {
      this.$router.push({
        path: this.getRoutesPath('category_product_more', item['identification'], item['id'])
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    }
  }
};
</script>

<style scoped lang="less">
.d-prod {
  background: #f2f2f2;
  .process {
    height: 30px;
    line-height: 30px;

    .step {
      font-size: 1.1428rem;
      color: #FFF;
      float: left;
      padding: 0 20px;
      margin: 0 20px 0 0;
      min-width: 100px;
      text-align: center;
      border-radius: 0.2rem;
      cursor: pointer;
      position: relative;
      background: #B8B0D4;
      &:hover {
        background: #635796;
        color: #FFF;

        &:before {
          content: '';
          position: absolute;
          bottom: -5px;
          left: calc(50% - 2.5px);
          width: 10px;
          height: 10px;
          background: #635796;
          transform: rotate(45deg);
        }
      }
      &:not(:last-child):after {
        content: '';
        float: right;
        width: 2px;
        height: 20px;
        background: #635796;
        right: -10px;
        top: 5px;
        position: absolute;
      }
    }

    .isActived {
      background: #635796;

      &:before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: calc(50% - 2.5px);
        width: 10px;
        height: 10px;
        background: #635796;
        transform: rotate(45deg);
      }
    }
  }
  .list {
    min-width: 75rem;
    .l-card {
      width: calc((100% - 180px) / 5);
      padding: 0.625rem 0 1.75rem;
      text-align: center;
      cursor: pointer;
      .l-img {
        width: 100%;
        height: 6.25rem;
      }
    }
    .l-card + .l-card {
      margin-left: 1.25rem;
    }
  }
  @media screen and (max-width: 1400px) {
    .process {
      padding: 0 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .process {
      padding: 0 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .process {
      padding: 0 15%;
    }
  }
}
</style>
